@if(teams.length === 1){
    <div class="mono-team-box rounded">
        <mat-chip-listbox>
            <mat-chip [removable]="false" color="accent" selected>
                {{ teams[0].name }}
            </mat-chip>
        </mat-chip-listbox>
    </div>
}@else{
    <mat-form-field class="my-2 w-100">
        <!-- <mat-label>Select Team(s):</mat-label> -->
        <mat-select [formControl]="teamsCtrl" multiple>
            <mat-select-trigger>
                <mat-chip-listbox>
                    @for(team of teamsCtrl.value; track teamsCtrl.value){
                        <mat-chip [removable]="true" (removed)="onTeamRemoved(team)" color="accent" selected>
                            {{ team.name }}
                            <span matChipRemove><i class="fa-regular fa-xmark text-white"></i></span>
                        </mat-chip>
                    }
                </mat-chip-listbox>
            </mat-select-trigger>
    
            @for(team of teams; track team.id){
                <mat-option [value]="team">
                    {{ team.name }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
}
